import { useQuery } from "@tanstack/react-query";
import { getFormDetails } from "@/api";
import { createContext, useState } from "react";

const FormContext = createContext(undefined);

const FormDispatchContext = createContext(undefined);

export function FormProvider({ children }: any) {
  const [formValues, setFormValues] = useState({});

  // useQuery(["enrollmentFormDetail"], (id) => getFormDetails(id), {
  //   onSuccess(data) {
  //     const result = {};
  //     const answers = JSON.parse(data.form.answer);
  //     for (let i = 0; i < answers.length; i++) {
  //       Object.assign(result, answers[i].subAnswer);
  //     }
  //     setFormValues(result);
  //   },
  // });

  return (
    <FormContext.Provider value={formValues as any}>
      <FormDispatchContext.Provider value={setFormValues as any}>
        {children}
      </FormDispatchContext.Provider>
    </FormContext.Provider>
  );
}
